import { capitalize } from 'lodash';

export function capitalizeWords(str: string): string | undefined {
    if (str) {
        return str
            .split(' ')
            .map((x) => capitalize(x))
            .join(' ');
    }

    return undefined;
}

// Do we need this function?
export function getCapitalizedCase(text: string): string {
    if (!text) {
        return '';
    }

    if (text === text.toUpperCase()) {
        return text.charAt(0).toUpperCase() + text.toLowerCase().substring(1);
    } else {
        return text.charAt(0).toUpperCase() + text.substring(1);
    }
}
